import React, { useState } from "react";
import styles from "../styles/home.module.css";
import NavigationBar from "../components/NavBar";

const ResidentPortal = () => {
  const [activeTab, setActiveTab] = useState("payment");

  return (
    <>
    <NavigationBar/>

    {/* Sidebar Section */}
    <div className={styles.residentPortal}>

      <aside className={styles.sidebar}>
        <h2>My Account</h2>
        <ul>
          <li onClick={() => setActiveTab("payment")}>💳 Make a Payment</li>
          <li onClick={() => setActiveTab("documents")}>📂 Documents</li>
        </ul>

        <h2>Maintenance</h2>
        <ul>
          <li onClick={() => setActiveTab("maintenance")}>🛠 Request Repair</li>
        </ul>

        <h2>Services</h2>
        <ul>
          <li onClick={() => setActiveTab("shop")}>🛍 Shop</li>
          <li onClick={() => setActiveTab("houseHelp")}>🧹 House Help</li>
        </ul>
      </aside>

      <main className={styles.mainContent}>

        <p style={{color:"#0041D9"}}>Welcome to your resident portal. Manage your payments, documents, and more.</p>
        <h1 style={{marginTop: "15px", fontSize:"20px"}}>🏡 The Greenview Apartments</h1>

    
    {activeTab === "payment" && (
        <div className={styles.paymentSection}>
            <h2 style={{marginTop: "15px", fontSize:"20px", color:"#0041D9"}}>Make a Payment</h2>
            
            <p>
                Rent Due: <strong>$1,200</strong> (Due: March 1st, 2025)
                <button className={styles.payButton}>Pay Now</button>
            </p>

            <h3 style={{marginTop: "15px"}}>Payment History</h3>
            <table className={styles.paymentTable}>
            <thead>
                <tr>
                <th>Month</th>
                <th>Amount</th>
                <th>Payment Date</th>
                <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr className={styles.paid}>
                <td>January 2025</td>
                <td>$1,200</td>
                <td>Jan 3, 2025</td>
                <td>✅</td>
                </tr>
                <tr className={styles.paid}>
                <td>February 2025</td>
                <td>$1,200</td>
                <td>Feb 2, 2025</td>
                <td>✅</td>
                </tr>
                <tr className={styles.pending}>
                <td>March 2025</td>
                <td>$1,200</td>
                <td>-</td>
                <td>❌</td>
                </tr>
            </tbody>
            </table>
        </div>
    )}


    {activeTab === "documents" && (
    <div className={styles.documentsSection}>
        <h2>Documents</h2>
        <ul className={styles.documentList}>
        <li className={styles.documentItem} onClick={() => console.log("Opening Lease Agreement")}>
            📜 Lease Agreement.pdf
        </li>
        <li className={styles.documentItem} onClick={() => console.log("Opening Payment Receipts")}>
            📄 Payment Receipts
        </li>
        </ul>
    </div>
    )}

    {activeTab === "maintenance" && (
    <div className={styles.maintenanceSection}>
        <h2>Maintenance Requests</h2>
        <button className={styles.requestButton} onClick={() => console.log("Requesting Repair")}>
        🛠 Request Repair
        </button>
        <ul className={styles.maintenanceList}>
        <li className={styles.maintenanceItem} onClick={() => console.log("Viewing Plumbing Issue")}>
            🚰 Plumbing Issue - Pending
        </li>
        <li className={styles.maintenanceItem} onClick={() => console.log("Viewing Light Fixture Repair")}>
            💡 Light Fixture Repair - Completed ✅
        </li>
        </ul>
    </div>
    )}


        {activeTab === "shop" && (
            <div className={styles.shopSection}>
            <h2 className={styles.maintenanceItem}>Apartment Shop</h2>
            <p className={{fontfamily:"Poppins", fontWeight:"100"}}>Order cleaning supplies, groceries, and more.</p>
          </div>
        )}

        {activeTab === "houseHelp" && (
            <div className={styles.houseHelpSection}>
            <h2>House Help Services</h2>
            <p>Book cleaning and maintenance services.</p>
          </div>
        )}
      </main>
    </div>
</>
  );
};

export default ResidentPortal;
